import { render, staticRenderFns } from "./WarehouseBox.vue?vue&type=template&id=0c02d330&scoped=true"
import script from "./WarehouseBox.vue?vue&type=script&lang=js"
export * from "./WarehouseBox.vue?vue&type=script&lang=js"
import style0 from "./WarehouseBox.vue?vue&type=style&index=0&id=0c02d330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c02d330",
  null
  
)

export default component.exports